// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2724":"dc4808746c14259c","3874":"9ac96175d6389d68","4057":"573e1524664c8e7e","4802":"b10b13869f6b8c3f","5129":"b00ed1edcb58f3f9"}[chunkId] + ".js";
};